<template>
  <SidebarFluxo
    class="rete-stage-options"
    v-bind="$attrs"
    :active-node="activeNode"
    :childrens="childrens"
    :modern-editor="true"
    v-on="$listeners"
  >
    <template #header>
      <header class="rete-stage-options__header">
        <div class="rete-stage-options__identity">
          <span class="rete-stage-options__icon" aria-hidden="true">
            <i
              :class="isDecision ? 'fas fa-code-branch' : 'fas fa-sliders-h'"
            ></i>
          </span>
          <div class="rete-stage-options__heading">
            <div class="rete-stage-options__eyebrow">
              OPÇÕES DO ESTÁGIO
              <span class="rete-stage-options__id">#{{ activeNode.id }}</span>
            </div>
            <h2>{{ activeNode.label || activeNode.ces_nome || "Estágio" }}</h2>
          </div>
          <button
            class="rete-stage-options__action"
            type="button"
            title="Sobre este estágio"
            aria-label="Sobre este estágio"
            @click="$emit('abrirModalInformacoesEstagio')"
          >
            <i class="far fa-question-circle" aria-hidden="true"></i>
          </button>
          <button
            class="rete-stage-options__action"
            type="button"
            title="Fechar opções"
            aria-label="Fechar opções do estágio"
            @click="$emit('fechar')"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="rete-stage-options__section">
          <i class="fas fa-sliders-h" aria-hidden="true"></i>
          Parâmetros
        </div>
      </header>
    </template>
    <template #form-intro>
      <div class="rete-stage-options__intro">
        <h3>
          {{ isDecision ? "Regras de decisão" : "Configuração do estágio" }}
        </h3>
        <p>
          {{
            isDecision
              ? "Defina as condições para cada caminho do fluxo."
              : "Ajuste os parâmetros usados nesta etapa do fluxo."
          }}
        </p>
      </div>
    </template>
    <template #decision-summary>
      <div class="rete-stage-options__summary" aria-label="Conexões de saída">
        <div>
          <span>Conectados</span>
          <strong>{{ childrens.length }}</strong>
        </div>
        <div>
          <span>Mínimo</span>
          <strong>{{ activeNode.ces_metadata.qtd_min_filho }}</strong>
        </div>
        <div>
          <span>Máximo</span>
          <strong>{{ activeNode.ces_metadata.qtd_max_filho }}</strong>
        </div>
      </div>
    </template>
  </SidebarFluxo>
</template>

<script>
import SidebarFluxo from "./SidebarFluxo.vue";

// Reutiliza todos os campos e eventos; esta camada visual só é montada no Rete.
export default {
  name: "ReteStageOptions",
  inheritAttrs: false,
  components: { SidebarFluxo },
  props: {
    activeNode: { type: Object, required: true },
    childrens: { type: Array, default: () => [] }
  },
  computed: {
    isDecision() {
      return Number(this.activeNode.chatbot_estagio_id) === 10;
    }
  }
};
</script>

<style lang="scss" scoped>
.rete-stage-options.sidebar-container.sidebar-container--modern {
  background: #fff;
  border: 1px solid #e4e4ed;
  border-radius: 16px;
  box-shadow: 0 20px 60px -12px rgba(28, 22, 45, 0.24),
    0 4px 16px rgba(28, 22, 45, 0.06);
  color: #292637;
  isolation: isolate;
  scrollbar-color: #d9d5e3 transparent;
  scrollbar-width: thin;

  .rete-stage-options__header {
    background: #fff;
    border-radius: 15px 15px 0 0;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .rete-stage-options__identity {
    align-items: center;
    display: flex;
    gap: 10px;
    padding: 20px 18px 18px;
  }
  .rete-stage-options__icon {
    align-items: center;
    background: #f1ecfa;
    border: 1px solid #e6dcf5;
    border-radius: 12px;
    color: #7045a3;
    display: inline-flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
    font-size: 16px;
  }
  .rete-stage-options__heading {
    flex: 1;
    min-width: 0;
    h2 {
      color: #292637;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.4;
      margin: 5px 0 0;
      overflow-wrap: anywhere;
    }
  }
  .rete-stage-options__eyebrow {
    align-items: center;
    color: #777184;
    display: flex;
    flex-wrap: wrap;
    font-size: 9px;
    font-weight: 700;
    gap: 6px;
    letter-spacing: 0.06em;
  }
  .rete-stage-options__id {
    background: #f3f1f7;
    border-radius: 4px;
    color: #6f627f;
    font-size: 10px;
    letter-spacing: 0;
    padding: 2px 5px;
  }
  .rete-stage-options__action {
    align-items: center;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 8px;
    color: #81788f;
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    padding: 0;
    transition: background 0.15s, color 0.15s;
    &:hover {
      background: #f3eff9;
      color: #60378e;
    }
    &:focus-visible {
      outline: 2px solid #9872c8;
      outline-offset: 2px;
    }
  }
  .rete-stage-options__section {
    align-items: center;
    background: #faf9fc;
    border-bottom: 1px solid #eeebf3;
    border-top: 1px solid #f1eef6;
    color: #6c4796;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 8px;
    padding: 12px 22px;
    i {
      font-size: 11px;
    }
  }
  .rete-stage-options__intro {
    margin-bottom: 22px;
    h3 {
      color: #393244;
      font-size: 13px;
      font-weight: 700;
      margin: 0 0 6px;
    }
    p {
      color: #81798d;
      font-size: 12px;
      line-height: 1.6;
      margin: 0;
    }
  }
  .rete-stage-options__summary {
    background: #f8f7fb;
    border: 1px solid #ece8f3;
    border-radius: 10px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 22px;
    padding: 13px 0;
    div {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 0 14px;
      &:not(:last-child) {
        border-right: 1px solid #e7e2ef;
      }
    }
    span {
      color: #84798f;
      font-size: 10px;
    }
    strong {
      color: #5e437c;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.2;
    }
  }

  // Todos os seletores do formulário ficam sob a classe exclusiva do Rete.
  ::v-deep .fluxo-inputs-container {
    padding: 22px;
    > div > .mt-3 {
      margin-top: 20px !important;
    }
  }
  ::v-deep .text-title {
    color: #51485f;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.55;
    margin-bottom: 8px;
  }
  ::v-deep .title-container {
    gap: 10px;
    margin-bottom: 6px;
  }
  ::v-deep .form-control,
  ::v-deep .p-dropdown,
  ::v-deep .p-multiselect,
  ::v-deep .p-chips-multiple-container {
    background: #fff;
    border: 1px solid #ded9e7;
    border-radius: 9px;
    box-shadow: 0 1px 2px rgba(35, 24, 52, 0.03);
    color: #393244;
    font-size: 13px;
    min-height: 42px;
    transition: border-color 0.15s, box-shadow 0.15s;
    &:hover {
      border-color: #bcb0cc;
    }
    &:focus,
    &.p-focus {
      border-color: #9974c5;
      box-shadow: 0 0 0 3px rgba(126, 86, 174, 0.1);
    }
  }
  ::v-deep textarea.form-control {
    line-height: 1.7;
    padding: 12px;
    resize: vertical;
  }
  ::v-deep .p-dropdown-label,
  ::v-deep .p-multiselect-label {
    font-size: 13px;
    padding: 10px 12px;
  }
  ::v-deep .p-dropdown-trigger,
  ::v-deep .p-multiselect-trigger {
    color: #968b9f;
    width: 34px;
  }
  ::v-deep .p-placeholder,
  ::v-deep .form-control::placeholder {
    color: #9a91a5;
    font-size: 12px;
  }
  ::v-deep .p-togglebutton.p-button {
    border-radius: 8px;
    font-size: 11px;
    min-height: 38px;
    text-transform: none !important;
  }
  ::v-deep .tomar-decisao-item {
    background: #fff;
    border: 1px solid #e7e1ef;
    border-left: 1px solid #e7e1ef;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(37, 25, 53, 0.03);
    margin: 16px 0;
    padding: 16px;
    &:empty {
      display: none;
    }
    h6 {
      background: #f6f3fb;
      border-bottom: 1px solid #ece6f4;
      border-radius: 11px 11px 0 0;
      color: #654585;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.5;
      margin: -16px -16px 16px;
      padding: 12px 16px;
      overflow-wrap: anywhere;
    }
    hr {
      display: none;
    }
  }
  ::v-deep .tooltip-container {
    i {
      color: #9c8aac;
      font-size: 12px;
    }
    .tooltip-mensagem {
      border-radius: 8px;
      max-width: 260px;
      .text-title {
        color: #fff;
        font-size: 11px;
      }
    }
    &:focus-within .tooltip-mensagem {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
